import { CurrencyEuroIcon, CurrencyPoundIcon } from "@heroicons/react/20/solid";

export function CurrencyIcon({ jurisdiction, ...props }) {
	const Icon = (() => {
		switch (jurisdiction) {
			case "UK":
				return CurrencyPoundIcon;
			case "MT":
			default:
				return CurrencyEuroIcon;
		}
	})();

	return <Icon {...props} />;
}
